module.exports = new __parcel__URL__("sloth.f3e9da22.svg").toString();